import { ComponentPropsWithoutRef } from 'react'

export function LogoTwitter20(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path d="M6.29 18.254c7.547 0 11.675-6.253 11.675-11.675q0-.266-.012-.53A8.3 8.3 0 0 0 20 3.924a8.2 8.2 0 0 1-2.356.646 4.12 4.12 0 0 0 1.804-2.27 8.2 8.2 0 0 1-2.606.996A4.104 4.104 0 0 0 9.85 7.039a11.65 11.65 0 0 1-8.458-4.287 4.1 4.1 0 0 0 1.27 5.477 4.06 4.06 0 0 1-1.858-.513l-.001.052a4.104 4.104 0 0 0 3.292 4.023 4.1 4.1 0 0 1-1.853.07 4.11 4.11 0 0 0 3.833 2.85 8.23 8.23 0 0 1-5.096 1.757A8 8 0 0 1 0 16.411a11.6 11.6 0 0 0 6.29 1.843" />
    </svg>
  )
}
